var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { normalizeObject, dataLayerPush, dataLayerPushEcommerce, SPONSORSHIP_PRODUCT_SKU, delay } from "../shared/utils";
function listToStr(val) {
    if (Array.isArray(val)) {
        return val.join(",");
    }
    return (val).toString();
}
function getNumberOfChildrenLoaded() {
    return document.querySelectorAll(".children-grid [class*='child-index']").length;
}
function parseSearchData(searchData) {
    var _a;
    var _b = searchData.search_params, search_params = _b === void 0 ? null : _b, _c = searchData.search_props, search_props = _c === void 0 ? {} : _c, _d = searchData.search_method, search_method = _d === void 0 ? "" : _d, _e = searchData.search_state, search_state = _e === void 0 ? null : _e;
    var search_params_values = search_params || search_state || {};
    var search_by = (search_props === null || search_props === void 0 ? void 0 : search_props.tabSelected) || "";
    var number_children_shown = getNumberOfChildrenLoaded();
    var search_selected_value = [
        ((_a = search_params_values === null || search_params_values === void 0 ? void 0 : search_params_values.countryCodes) === null || _a === void 0 ? void 0 : _a.length) && listToStr(search_params_values.countryCodes) || "no preference",
        search_params_values.gender || "no preference",
        search_params_values.minimumAge || "no preference",
        search_params_values.minimumBirthMonth || "no preference",
        search_params_values.minimumBirthDayOfMonth || "no preference"
    ].join(":");
    if (search_by === "curated") {
        var search_value = (search_props === null || search_props === void 0 ? void 0 : search_props.curatedSearchSelected) || "";
        return { search_value: search_value, search_by: search_by, number_children_shown: number_children_shown };
    }
    else if (search_by === "detail") {
        return { search_value: search_selected_value, search_by: search_by, number_children_shown: number_children_shown };
    }
    return { search_value: "", search_by_need_value: "", search_selected_value: search_selected_value, search_by: search_by, number_children_shown: number_children_shown, search_method: search_method };
}
function parseSponData(sponData) {
    var _a = (sponData === null || sponData === void 0 ? void 0 : sponData.search_props) || (sponData === null || sponData === void 0 ? void 0 : sponData.child_props) || {}, identifier = _a.identifier, position = _a.id, community_name = _a.projectName, child_country = _a.countryName;
    var link_text = sponData === null || sponData === void 0 ? void 0 : sponData.link_text;
    var child_id = identifier || (sponData === null || sponData === void 0 ? void 0 : sponData.childId);
    var destination_url = (sponData === null || sponData === void 0 ? void 0 : sponData.destination_url) || "";
    return { child_id: child_id, position: position, community_name: community_name, child_country: child_country, destination_url: destination_url, link_text: link_text };
}
function parseInteractions(triggerData) {
    var _a = triggerData.data, data = _a === void 0 ? {} : _a;
    var event_action = (data || {}).event_action;
    var label_value_map = {
        "curated": "Search By Need",
        "detail": "Search By Details"
    };
    var _b = parseSearchData(data), search_value = _b.search_value, search_by = _b.search_by, search_method = _b.search_method;
    if (event_action === "child_finder_tab_click") {
        return {
            event_action: event_action,
            event_label: label_value_map[search_by || ""] || search_method
        };
    }
    else if (search_by === "detail") {
        return {
            event_action: "search_by_detail",
            event_label: search_value
        };
    }
    else if (search_by === "curated") {
        return {
            event_action: "search_by_need",
            event_label: search_value
        };
    }
    return { event_action: "", event_label: "" };
}
/*
    sponsorship_finder_interactions - includes
    - child_finder_tab_click
    - search_by_detail
    - search_by_need
*/
export function sponAppChildInteractions(e) {
    var _a = parseInteractions((e === null || e === void 0 ? void 0 : e.detail) || {}), event_action = _a.event_action, event_label = _a.event_label;
    if (!event_action) {
        return;
    }
    var eventData = normalizeObject({
        "event": "sponsorship_finder_interactions",
        "event_action": event_action,
        "event_category": "sponsorship_finder",
        "event_label": event_label,
        "non_interaction": false,
    });
    dataLayerPush(eventData);
}
// Children Grid View: (column AA)
export function sponAppChildGridView(e) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, data, _b, search_value, number_children_shown, event_label, eventData;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = ((e === null || e === void 0 ? void 0 : e.detail) || {}).data, data = _a === void 0 ? {} : _a;
                    // Adding this extra delay as workaround to get the sponsorship grid list count
                    return [4 /*yield*/, delay(2000)];
                case 1:
                    // Adding this extra delay as workaround to get the sponsorship grid list count
                    _c.sent();
                    _b = parseSearchData(data), search_value = _b.search_value, number_children_shown = _b.number_children_shown;
                    event_label = "".concat(search_value, "-").concat(number_children_shown);
                    eventData = normalizeObject({
                        "event": "sponsorship_child_grid_view",
                        "event_action": "sponsorship_child_grid_view",
                        "event_category": "sponsorship_finder",
                        "event_label": event_label,
                        "non_interaction": true,
                        "standard_interactions": 1,
                        "std_plp_view": 1,
                    });
                    dataLayerPush(eventData);
                    return [2 /*return*/];
            }
        });
    });
}
// Child Card Click (column AB)
export function sponAppCardClick(e) {
    var data = (e.detail || {}).data;
    var search_selected_value = parseSearchData(data).search_selected_value;
    var _a = parseSponData(data), child_id = _a.child_id, position = _a.position, community_name = _a.community_name, child_country = _a.child_country;
    var event_label = search_selected_value;
    var eventData = normalizeObject({
        "event": "sponsorship_child_card_click",
        "event_action": "sponsorship_child_card_click",
        "event_category": "sponsorship_finder",
        "event_label": event_label,
        "child_id": child_id,
        "child_position": position,
        "child_community_name": community_name,
        "child_country": child_country,
        "non_interaction": false,
    });
    dataLayerPush(eventData);
}
// Child page VPV (column AC)
// Child Grid page VPV (On Subsequent Grid Views) 
export function sponAppPageView(e) {
    return __awaiter(this, void 0, void 0, function () {
        var data, display_type, title, page_path, page_location, page_title, eventData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, delay(10)];
                case 1:
                    _a.sent();
                    data = (e.detail || {}).data;
                    display_type = data.display_type, title = data.title;
                    page_path = window.location.pathname + window.location.search;
                    page_location = window.location.href;
                    page_title = title || window.document.title;
                    eventData = normalizeObject({
                        "event": "page_view",
                        "page_display_type": display_type,
                        "page_location": page_location,
                        "page_path": page_path,
                        "page_title": page_title,
                    });
                    dataLayerPush(eventData);
                    return [2 /*return*/];
            }
        });
    });
}
// Child View (Column AE)
export function sponAppChildDetailView(e) {
    var data = (e.detail || {}).data;
    var _a = parseSponData(data), child_id = _a.child_id, community_name = _a.community_name, child_country = _a.child_country;
    var eventData = normalizeObject({
        "event": "view_item",
        "event_action": "child_detail_view",
        "event_category": "ecommerce",
        "event_label": "child_sponsorship",
        "standard_interactions": 1,
        "std_pdp_view": 1,
        "child_id": child_id,
        "child_community_name": community_name,
        "child_country": child_country,
        "ecommerce": {
            "items": [{
                    "item_brand": "sponsorship",
                    "item_category": "sponsorship",
                    "item_id": SPONSORSHIP_PRODUCT_SKU,
                    "item_variant": "monthly:39",
                    "item_name": "child_sponsorship",
                    "price": "39",
                    "quantity": 1
                }
            ]
        },
        "non_interaction": true,
    });
    dataLayerPushEcommerce(eventData);
}
// Copy Share Link (column AF)
export function sponAppShareCopy(e) {
    var data = (e.detail || {}).data;
    var _a = parseSponData(data), child_id = _a.child_id, community_name = _a.community_name, child_country = _a.child_country, destination_url = _a.destination_url, link_text = _a.link_text;
    var eventData = normalizeObject({
        "event": "child_share_copy_link",
        "event_action": "child_share_copy_link",
        "event_category": "share_link_click",
        "event_label": "".concat(link_text, ":").concat(destination_url),
        "child_id": child_id,
        "child_community_name": community_name,
        "child_country_name": child_country,
        "adv_child_share_link_copy": 1,
        "advocate_interactions": 1,
        "non_interaction": false
    });
    dataLayerPush(eventData);
}
// Sponsor Me Click (column AK)
export function sponAppAddToCart(e) {
    var data = (e.detail || {}).data;
    var _a = parseSponData(data), child_id = _a.child_id, community_name = _a.community_name, child_country = _a.child_country;
    var eventData = normalizeObject({
        "event": "add_to_cart",
        "event_action": "add_to_cart",
        "event_category": "ecommerce",
        "event_label": "child_sponsorship",
        "child_community_name": community_name,
        "child_country_name": child_country,
        "child_id": child_id,
        "hi_add_to_carts": 1,
        "high_intent_interactions": 1,
        "ecommerce": {
            "items": [{
                    "item_brand": "sponsorship",
                    "item_category": "sponsorship",
                    "item_id": SPONSORSHIP_PRODUCT_SKU,
                    "item_variant": "monthly:39",
                    "item_name": "child sponsorship",
                    "price": "39",
                    "quantity": 1,
                }]
        }
    });
    dataLayerPushEcommerce(eventData);
}
